// @flow
import decodeGiftImage from './decodeGiftImage';

type Product = {
  id: number,
  name: string,
  image: {
    res1x: string,
    res2x: string
  },
  price: number
};

function decodeProduct(p: Object = {}): Product {
  return {
    id: p.id || p.name,
    name: p.name,
    image: decodeGiftImage(p.image),
    price: p.price
  };
}

export default decodeProduct;
